/*	MARK: Samantia Machine Forecast
	============================================
 */
/** Imports **/
import { inject, PLATFORM } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request, AuthRequest } from '../services/data-service';
import { Api } from '../services/api';
import { MachineStatus, MachineSignal } from './machine-schemas';
import { ZSC, Sammy, SammyLight } from './palette';

import { NavOptionMenu } from './nav-option-menu';

const ObjectID = require('bson-objectid');
import Plotly from 'plotly.js-dist-min';
// Events
import { EventAggregator } from 'aurelia-event-aggregator';
import { NotificationEvent } from './notification'

const Stages = {
	Upload:"Upload", Ready:"Ready",
	InProcess:"InProcess", Done:"Done"
}

const OperSerie = {"serie":"time_series_predict", "multivar_serie":"time_series_multivar_predict" };

@inject(DataService, Api, Router, EventAggregator)
export class MachineForecast {

	/** Components methods **/
	constructor(ds, api, router, ea){
		// Services
		this.ds		= ds;
		this.api	= api;
		this.router = router;
		this.ea		= ea;

		// Process status of forecast
		this.inProcess		= false;
		this.selectedPeriod = 1;
		// Stages
		this.Stages	= Stages;
		this.stage	= Stages.Ready;
		this.accessToken = "";
		// Testing
		this.navOptionMenu = new NavOptionMenu(ds, api, router, ea);
	}
	activate(params){ this.id = params.id; this.pid = params.pid } // MachineID
	
	attached(){
		/*	============================================
		  	1 Get machine from dataservice
			2 Get dataset from machine.dataset(split name)
			3 Setup machine and dataset to DataService
			============================================
		*/
		window.setTimeout( () => {this.init();}, 300);
		// Subscriptions
		//this.savedPredictionSubs = this.ea.subscribe(NotificationEvent.PredictionSaved, msg => this.onSavedPrediction(msg));
		this.predictionDownloadSubs = this.ea.subscribe(NotificationEvent.PredictionDownload, msg => this.onPredictionDownload(msg));
	}

	detached(){ this.predictionDownloadSubs.dispose();}
	
	init(){
		/*	============================================
		  	1 Get machine from dataservice
			2 If machine existis, procede to get dataset
			  else -> get remote machine and dataset
			3 Setup machine and dataset to DataService
			============================================
		*/
		let machine = this.ds.app_data.machine;

		if(!machine){
			// Get remote machine data
			this.getMachine(this.id).then(response => {
				this.handleMachineResponse(response);
				// Get dataset?
				// Load Archive prediction (PID) if need id
				if(this.pid){ this.loadArchive(this.pid) }
			});
		}
		else{
			this.machine = machine;
			this.ds.app_data.machine = machine;
			// Load Archive prediction (PID) if need id
			if(this.pid){ this.loadArchive(this.pid) }
		}

	}

	
	/** Init Archive ***/
	loadArchive(pid){
		// Change Stage status (in process)
		this.stage = Stages.InProcess;

		// Load remote data
		this.getPrediction(pid).then(response => {
			this.handleGetPrediction(response);
		});
	}

	/** API Calls
		============================================
	**/

	getPrediction(pid){
		let id			= this.machine._id;
		let request 	= new Request("/api/v2/machines/"+id+"/predictions/"+pid, "GET");
		return this.api.get(request);
	}

	handleGetPrediction(response){
		// Display prediction
		if(response.status === 200){
			this.stage	= Stages.Done;
			let data	= response.data;
			// To data Service
			this.predictionToDataService(data);
			// Plot data
			window.setTimeout( () => {
				try{this.plotTimeSerie(this.machine, data);}
				catch(e){
					console.log("e=>", e);
				}}, 1);
		}
	}

	getMachine(id){
		// Request
		let request 	= new Request("/api/v2/machines/id?", "GET");
		let params  	= new URLSearchParams({ id:id });
		request.url 	= request.url + params;
		// Perform remote call
		return this.api.get(request);
	}

	handleMachineResponse(response){
		let status = response.status;

		if(status === 200){
			let machine  = response.data;
			machine.features = machine.features
			this.machine = machine;
			this.ds.app_data.machine = machine;
			
		};
	}


	requestQuota(machine){
		// Auth Request
		let subsToken		= this.ds.user.subs;
		let uid				= machine.uid;
		let request			= new AuthRequest("/api/v2/users/"+uid+"/usage-token", "POST");
		
		let machine_quota 	= { quota: machine.stats.lag_period } // prediction
		let body			= { machine_quota:machine_quota, uid:machine.uid };
		// Add body
		request.body		= JSON.stringify(body);
		// Add subs header
		request.headers["Authorization"] = "Bearer " + subsToken; // Bearer + token
		return this.api.post(request);
	}
	

	postSeriePrediction(machine){
		// Machine ID
		let id 				= machine._id;
		// Create request
		let request 	= new Request("/api/v2/machines/" + id + "/predict/", "POST");

		// Add Auth token
		let token		= this.ds.user.subs;
		// request.headers["Authorization"] = "Bearer " + this.token; // Bearer + token
		request.headers["Authorization"] = "Bearer " + this.accessToken; // Bearer + token

		// Copy machine
		let req_machine = { ... machine };
		let oper		= OperSerie[req_machine.algorithm]
		let body 		= {
			oper:oper,
			signal:MachineSignal.Predict,
			machine:req_machine,
			sample:machine.sample
		};

		request.body	= JSON.stringify(body);
		// Perform api call - Train
		return this.api.post(request);
	}

	handlePostSeriePrediction(response){
		let status = response.status;
		if(status === 200){
			let json_response = JSON.parse(response.data);
			let data 		  = json_response.data; // predictions, serie, timestamps

			// Plot series
			let ai_status 	= json_response.code
			if(ai_status === 200){

				// To DataService
				this.stage	= Stages.Done;
				this.predictionToDataService(data);
				// break piont // console.log("pred data => ", data);
				window.setTimeout( () => {
					try{this.plotTimeSerie(this.machine, data);}catch(e){ console.log("e=>", e);}
				}, 1);
			}
			else{
				// Send message
				this.stage 	= Stages.Ready;
				// Send Notification
				this.ea.publish(NotificationEvent.SysError, { body:"Error in forecast model" });
			}
			return data;
		}
		else{
			// Send message
			this.stage 	= Stages.Ready;
			this.ea.publish(NotificationEvent.SysError, { body:"Error in forecast model" });
		}
	}
	

	/** Actions
		============================================
	**/

	predictionToDataService(pred){
		let credentials = {
			uid		:this.machine.uid,
			muid	:this.machine._id,
			type	:"Forecast"
		}

		let data = {... pred };

		data.credentials = credentials;
		data._id	= (this.pid) ? this.pid : ObjectID(Date.now()).toHexString();
		
		this.ds.app_data.prediction = data;
	}

		
	done_time_series(){
		this.stage = Stages.InProcess;
		// Preapare data
		let lag = this.machine.stats.lag_period;
		this.machine.stats.lag_period = parseInt(lag);
		// Request quota
		let machine_quota = { ... this.machine };
		this.requestQuota(machine_quota).then(responseQuota => {
			let status = responseQuota.status;
			if(status === 200){
				this.accessToken = responseQuota.data.oper_token;
				// Prepare again
				let lag = this.machine.stats.lag_period;
				this.machine.stats.lag_period = parseInt(lag);
				return this.postSeriePrediction(this.machine);
			}
			else{
				return { status:404 }
			}
			
		})
		.then(res => {
			let res_data 	= this.handlePostSeriePrediction(res);
		});

	}

	
	onchange_lag_period(period){
		this.machine.stats.lag_period = period;
		this.done_time_series();
		return true;
	}

	display_tabular_data(X, y, label){

		// Reformat X data <- timestamps
		let timestamps 	= X.map( (x) => x.toISOString() );
		// timestamps 		= timestamps.reverse();
		//y 				= y.reverse();
		let xtime			= [ ... timestamps ].reverse();
		let yout			= [ ... y ].reverse();
		
		/** Tabular data */
		let tabular_data = {
			headers:[ "Timestamps", label ],
			// columns:[ timestamps, y ]
			columns:[ xtime, yout ]
		};
		
		/** End tabular data **/
		return tabular_data
	}
	
	// Setup timestamps series for plot serie
	setTimestamps(timeArray, lag){

		let dates_array	= timeArray.map( (x) => new Date(x) );
		let date2 		= dates_array[1];
		let date1 		= dates_array[0];
		
		let interval 	= date2 - date1 // diff in seconds

		for (let i=0; i < lag; i++){
			let l = dates_array.length;
			// buffer date
			let buffer_date = new Date(dates_array[ l - 1].getTime() + interval);
			dates_array.push(buffer_date);
		}
		return dates_array;
	}

	plotTimeSerie(machine, res_data){
		// Create Timestamps
		let lag_time	= (this.pid) ? res_data.predictions.length : machine.stats.lag_period
		//let timestamps 	= this.setTimestamps(res_data.timestamps, machine.stats.lag_period)
		let timestamps 	= this.setTimestamps(res_data.timestamps, lag_time)
		// Get interval
		let data 	= { "X":timestamps, "y":res_data.serie };


		// Historic serie 
		let ax	 	= {
			x: data.X, y:data.y, name:machine.y_label,
			// line:{ width:"1", color:Sammy.Lisa }
			line:{ width:"1", color:SammyLight.Blue } 
		};// ZSC.Lisa

		// Prediction serie
		// Concat last serie value
		let prediction_serie = [res_data.serie[ res_data.serie.length - 1]].concat(res_data.predictions);
		
		let ax2 	= {
			// x: data.X.slice( data.X.length - res_data.predictions.length), y:res_data.predictions,
			x: data.X.slice( data.X.length - (res_data.predictions.length + 1) ), y:prediction_serie,
			name:"Forecast",
			//line:{ width:"1", color:Sammy.Magenta }
			line:{ width:"1", color:SammyLight.Orange2}
		};

		let mean_val	= res_data.insights.mean;
		let ymean		= Array(data.X.length).fill(mean_val);
		let ax_mean = {
			x: data.X,
			y:ymean,
			name:"Mean",
			mode:"lines",
			line: { dash:"dot", width:"1", color:ZSC.SoftBlue }
		}

		let layout 	= {
			title		: machine.name,
			showlegend	:true,
			legend		:{ orientation:"h", y:5},
			yaxis		:{ side:"right" },
			borderRadius:"10px",
			plot_bgcolor: SammyLight.Gray,
			paper_bgcolor: SammyLight.Gray,
		};

		let plot_data = [ax, ax2];
		let config = {
			toImageButtonOptions:{
				format		:'png',
				file_name	:'output',
				height		:800,
				width		:1024,
				scale		:1
			},
			displaylogo:false,
			responsive:true,
			scrollZoom:true
			
		}

	
		Plotly.newPlot(this.board, plot_data, layout, config);
		// Display Tabular data
		let pred_X 		= data.X.slice(data.X.length - res_data.predictions.length)
		let pred_y 		= res_data.predictions
		
		let historic_X 	= data.X.slice(1,( (res_data.serie.length - 1) - (res_data.predictions.length -1) ) );
		let historic_y	= res_data.serie.slice(1, ( (res_data.serie.length - 1) - (res_data.predictions.length - 1)));
		
		this.tabular_prediction_data = this.display_tabular_data(pred_X, pred_y, machine.y_label)
		this.tabular_historic_data	 = this.display_tabular_data(historic_X, historic_y, machine.y_label)
	}


	/** MARK: Events
		=================================
	**/

	toImage(){
		let image_options = { format:'png',file_name:'output', height:800, width:1024,scale:1};
		Plotly.downloadImage(this.board, image_options);
	}

	onPredictionDownload(msg){
		this.toImage();
	}


}
